<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10">
          <trash-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Delete Type</h3>
          <div class="tw-mt-2">
            <p class="tw-font-thin tw-text-gray-600">Are you sure you want to delete this activity type?</p>
          </div>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="deleteTodoItemType" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="red">Confirm</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="red">
          Cancel
        </base-button>
      </div>
      <inline-error id="delete-activity-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import TrashIcon from "@/assets/svgs/trash-icon.svg";

export default {
  components: {
    InlineError,
    TrashIcon,
  },
  name: "DeleteTodoItemType",
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      todoItemTypeId: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    show(todoItemTypeId) {
      this.todoItemTypeId = todoItemTypeId;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    reset() {
      this.todoItemTypeId = null;
    },
    deleteTodoItemType() {
      this.isLoading = true;

      this.$axios
        .delete(`/businesses/${this.businessId}/todo/types/${this.todoItemTypeId}`)
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Activity Type Deleted",
            message: `Your activity type was deleted successfully.`,
          });
          this.$emit("typesUpdated", {});
          this.reset();
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Error deleting activity type`;
          this.errorMessage = "Sorry, we had trouble deleting this activity type. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
